/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-31 14:23:29
 * @LastEditors: linxi
 * @LastEditTime: 2021-06-02 12:04:28
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { api, sendAsync } from "../../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../../app/store";
import { getStockMaintenance, getStockMaintenanceDetail, maintenanceCompleted, removeStockMintenance, StockMaintenanceBody, StockMaintenanceParams, submitStockMaintenance } from "../../../../services/StockMaintenance";
interface StockMaintenance {
    stockMaintenanceData: [],
    stockMaintenanceTotal: 0,
    stockMaintenanceCurrent: 1,
    stockMaintenanceId: 0,
    stockMaintenanceDetail: any,
}

const initialState: StockMaintenance = {
    stockMaintenanceData: [],
    stockMaintenanceTotal: 0,
    stockMaintenanceCurrent: 1,
    stockMaintenanceId: 0,
    stockMaintenanceDetail: {},
};

export const submitStockMaintenanceAsync = createAsyncThunk<
    void, StockMaintenanceBody, RootThunkApi<void>
>("maintenance/submit", async (body, api) => {
    return sendAsync(submitStockMaintenance(body), api)
})

const stockMaintenanceSlice = createSlice({
    name: "stockMaintenanceSlice",
    initialState,
    reducers: {
        setData(state, action) {
            state.stockMaintenanceData = action.payload
        },
        setTotal(state, action) {
            state.stockMaintenanceTotal = action.payload
        },
        setCurrent(state, action) {
            state.stockMaintenanceCurrent = action.payload
        },
        setId(state, action) {
            state.stockMaintenanceId = action.payload
        },
        setDetail(state, action) {
            state.stockMaintenanceDetail = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(submitStockMaintenanceAsync.fulfilled, (state, action: any) => {
            state.stockMaintenanceId = action.payload
        })
    }
});

export const { setData, setTotal, setCurrent, setDetail, setId } = stockMaintenanceSlice.actions;


export const selectStockMaintenanceData = (state: RootState) => state.stockMaintenance.stockMaintenanceData;

export const selectStockMaintenanceTotal = (state: RootState) => state.stockMaintenance.stockMaintenanceTotal

export const selectStockMaintenanceCurrent = (state: RootState) => state.stockMaintenance.stockMaintenanceCurrent

export const selectStockMaintenanceId = (state: RootState) => state.stockMaintenance.stockMaintenanceId

export const selectStockMaintenanceDetail = (state: RootState) => state.stockMaintenance.stockMaintenanceDetail



export function getStockMaintenanceList(params: StockMaintenanceParams): RootThunk {
    return api(getStockMaintenance(params), (data: any, dispatch) => {
        dispatch(setData(data.records))
        dispatch(setTotal(data.total))
    });
}

export function getStockMaintenanceItem(id: number): RootThunk {
    return api(getStockMaintenanceDetail(id), (data, dispatch) => {
        dispatch(setDetail(data))
    })
}

export const removeStockMaintenanceAsync = createAsyncThunk<
    void, number, RootThunkApi<void>
>("maimtenance/remove", async (id, api) => {
    return sendAsync(removeStockMintenance(id), api)
})

export const maintenanceCompletedAsync = createAsyncThunk<
    void, number, RootThunkApi<void>
>("maintenance/completed", async (id, api) => {
    return sendAsync(maintenanceCompleted(id), api)
})



export default stockMaintenanceSlice.reducer;
